import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

interface AleaMittelIconProps extends IconProps {
  color?: string;
}

export const AleaMittelIcon: React.FC<AleaMittelIconProps> = ({ 
  color = '#2B4956', 
  ...props 
}) => {
  return (
    <Icon
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M36.3852 29.5674C36.3852 35.6574 31.4352 40.5874 25.3352 40.5874C19.2352 40.5874 14.2852 35.6474 14.2852 29.5674C14.2852 23.4874 25.3452 9.60742 25.3452 9.60742C25.3452 9.60742 36.3952 23.4774 36.3952 29.5674H36.3852Z" 
        fill="white" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M25.3439 40.5882C31.7538 40.5882 37.8039 35.6282 36.3939 27.6582H14.8939C13.2439 35.7982 18.9339 40.5882 25.3439 40.5882Z" 
        fill="#EDD766"
      />
      <path 
        d="M36.3852 29.5674C36.3852 35.6574 31.4352 40.5874 25.3352 40.5874C19.2352 40.5874 14.2852 35.6474 14.2852 29.5674C14.2852 23.4874 25.3452 9.60742 25.3452 9.60742C25.3452 9.60742 36.3952 23.4774 36.3952 29.5674H36.3852Z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default AleaMittelIcon; 